import {ReactNode} from "react";

export interface HeadingProps {
    mainText?: string;
    subText?: string;
    children?: ReactNode;
}

export default function Heading({children, mainText, subText}: HeadingProps) {
    return (
        <div style={{display: "flex", justifyContent: "space-between", margin: "20px 0px"}}>
            <div style={{display: "flex", flexDirection: "column", gap: "10px"}}>
                <span style={{fontSize: "18px", color: "#1a1919"}}>{mainText}</span>
                <span style={{fontSize: "10px", color: "#aeaeae"}}>{subText}</span>
            </div>
            <div>{children}</div>
        </div>
    );
}
